const SESSION_PREFIX = "form_prompt_dismissed_";
export function isFormDismissedThisSession(formId) {
    try {
        return sessionStorage.getItem(SESSION_PREFIX + formId) === "1";
    }
    catch (e) {
        return false;
    }
}
export function markFormDismissedSession(formId) {
    try {
        sessionStorage.setItem(SESSION_PREFIX + formId, "1");
    }
    catch (e) {
        /* ignore */
    }
}
export function clearFormDismissedSession(formId) {
    try {
        sessionStorage.removeItem(SESSION_PREFIX + formId);
    }
    catch (e) {
        /* ignore */
    }
}
export function resolveFormRouteContext(routeName, path) {
    if (routeName === "messenger" || path.indexOf("/messenger/") === 0) {
        return "messenger";
    }
    return "workplace";
}
